import { Checkbox } from '@thoughtspot/radiant-react/widgets/checkbox';
import React, { useCallback } from 'react';
import styles from './checkbox-input.module.scss';
export const CheckboxInput = ({ title, checked, onChange, name, disabled, }) => {
    const handleChange = useCallback((e) => {
        if (!disabled) {
            onChange(e);
        }
    }, [onChange, disabled]);
    return (React.createElement(Checkbox, { id: name, label: title, hideLabel: true, checked: checked, onChange: handleChange, disabled: disabled, ariaLabel: title, className: styles.checkbox, "data-testid": `feature-checkbox-${name}` }));
};
//# sourceMappingURL=checkbox-input.js.map